import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { wait } from "../../../utils/fn";
import { Content } from "../getContent/Content";
import { sessionStateMap } from "./persistence/map.dev";
import { strategies } from "./strategies/strategies";
import { getUrlParams } from "./utils";

// Create a function that accepts multiple strategies
export var checkUrl = function checkUrl(openWidget, setState) {
  var params = getUrlParams();

  // Find the first strategy whose predicate returns true
  var matchedStrategy = strategies.find(function (strategy) {
    return strategy.predicate(params);
  });
  if (!matchedStrategy) {
    return undefined;
  }
  openWidget();
  var content = Content.getInstance().getData();
  var logic = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _sessionStateMap$save, _matchedStrategy$requ;
      var sum;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return wait(content.requestSettings.default.delay);
          case 2:
            sum = (_sessionStateMap$save = sessionStateMap.saveSum) === null || _sessionStateMap$save === void 0 ? void 0 : _sessionStateMap$save.load();
            return _context.abrupt("return", (_matchedStrategy$requ = matchedStrategy.request(params, content, setState)) === null || _matchedStrategy$requ === void 0 ? void 0 : _matchedStrategy$requ.then(function (res) {
              return {
                status: res,
                sum: sum
              };
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function logic() {
      return _ref.apply(this, arguments);
    };
  }();
  return logic();
};